import { findValidForClass, findValidFor } from 'lib/uiHelpers';

const ListCard = ({ item }) => {
  const findValidForPlay = (type) => {
    switch (type) {
      case 'exhibition + play':
        return 'Exhibition & Play Space';
      case 'exhibition':
        return 'Exhibition Space ONLY';
      default:
        return 'Exhibition';
    }
  };

  if (item.category === 0) {
    return (
      <div className="bg-[#F3F2F0] p-3 rounded-lg mt-4">
        <ul className="flex flex-col gap-2">
          <li className="flex flex-row items-center font-medium gap-1">
            <div className="w-4 h-4 relative">
              <img
                alt="icon-dollar"
                src="/kin/assest/image/icon-dollar.svg"
                className="absolute inset-0 h-full w-full object-cover"
              />
            </div>
            <span className="text-kin-text text-sm block">One Time Payment</span>
          </li>
          <li className="flex flex-row items-center font-medium gap-1">
            <div className="w-4 h-4 relative">
              <img
                alt="icon-dollar"
                src="/kin/assest/image/icon-star.svg"
                className="absolute inset-0 h-full w-full object-cover"
              />
            </div>
            <span className="text-kin-text text-sm block">
              Valid for any {findValidForClass(item.type.toLowerCase())}
            </span>
          </li>
          <li className="flex flex-row items-center font-medium gap-1">
            <div className="w-4 h-4 relative">
              <img
                alt="icon-dollar"
                src="/kin/assest/image/icon-calender.svg"
                className="absolute inset-0 h-full w-full object-cover"
              />
            </div>
            <span className="text-kin-text text-sm block">
              Valid on{' '}
              <span className="capitalize">
                {item?.validity_period_month !== 0
                  ? `${item?.validity_period_month} Month`
                  : 'Everyday'}
              </span>
            </span>
          </li>
          <li className="flex flex-row items-center font-medium gap-1">
            <div className="w-4 h-4 relative">
              <img
                alt="icon-dollar"
                src="/kin/assest/image/icon-clock.svg"
                className="absolute inset-0 h-full w-full object-cover"
              />
            </div>
            <span className="text-kin-text text-sm block">
              Valid for{' '}
              {item.credit_number > 1
                ? `${item.credit_number} Classes`
                : `${item.credit_number} Class`}
            </span>
          </li>
        </ul>
      </div>
    );
  }

  return (
    <div className="bg-[#F3F2F0] p-3 rounded-lg mt-4">
      <ul className="flex flex-col gap-2">
        <li className="flex flex-row items-center font-medium gap-1">
          <div className="w-4 h-4 relative">
            <img
              alt="icon-dollar"
              src="/kin/assest/image/icon-dollar.svg"
              className="absolute inset-0 h-full w-full object-cover"
            />
          </div>
          <span className="text-kin-text text-sm block">One Time Payment</span>
        </li>
        <li className="flex flex-row items-center font-medium gap-1">
          <div className="w-4 h-4 relative">
            <img
              alt="icon-dollar"
              src="/kin/assest/image/icon-star.svg"
              className="absolute inset-0 h-full w-full object-cover"
            />
          </div>
          <span className="text-kin-text text-sm block">
            Valid for any {findValidFor(item?.category)}
          </span>
        </li>
        <li className="flex flex-row items-center font-medium gap-1">
          <div className="w-4 h-4 relative">
            <img
              alt="icon-dollar"
              src="/kin/assest/image/icon-calender.svg"
              className="absolute inset-0 h-full w-full object-cover"
            />
          </div>
          <span className="text-kin-text text-sm block">
            Valid on <span className="capitalize">{item?.type ? item?.type : '-'}</span>
          </span>
        </li>
        <li className="flex flex-row items-center font-medium gap-1">
          <div className="w-4 h-4 relative">
            <img
              alt="icon-dollar"
              src="/kin/assest/image/icon-clock.svg"
              className="absolute inset-0 h-full w-full object-cover"
            />
          </div>
          <span className="text-kin-text text-sm block">
            Valid for {item?.credit_number > 1 ? `${item.credit_number} Session` : `-`}
          </span>
        </li>
      </ul>
    </div>
  );
};

export default ListCard;
